module.exports = __webpack_public_path__ + "img/gamepad2.90a5b7e0.svg";